import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useGlobalStore } from '@/stores/global';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  const { sidebarCollapsed } = useGlobalStore();

  return (
    <div className="min-h-screen flex w-full relative overflow-hidden">
      {/* 科技感背景装饰 */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute inset-0 data-grid opacity-30"></div>
        <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-gradient-to-r from-primary/10 to-transparent blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full bg-gradient-to-l from-cyan-500/10 to-transparent blur-3xl"></div>
      </div>
      
      <Sidebar />
      
      <div className="flex-1 flex flex-col relative z-10">
        <Header />
        
        <main className={cn(
          'flex-1 p-6 overflow-auto',
          'transition-all duration-300'
        )}>
          {children}
        </main>
      </div>
    </div>
  );
};
